import styled from 'styled-components';
import { Button as BaseButton } from 'packages/smart-home-support/components';
import { partnerStyled } from 'packages/smart-home-support/partner';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import { getBreakpoint } from './utils';
import { threeCoachesPortraitUrl } from './resources';

const breakpoint = getBreakpoint();

export const PageContainer = styled.div`
  padding: 10px 25px;
  margin: 0 auto;
  max-width: 1200px;
`;

export const Heading1 = styled.h1`
  font-weight: bold;
  font-size: 32px;
  margin-top: 0px;
  margin-bottom: 15px;
  @media ${BREAK_POINTS.desktop} {
    font-size: 60px;
    margin-top: 40px;
    margin-bottom: 50px;
  }
`;

export const Heading2 = styled.h2`
  font-size: 24px;
  font-weight: bold;
  @media ${BREAK_POINTS.desktop} {
    font-size: 36px;
  }
  @media ${BREAK_POINTS.desktopBig} {
    font-size: 40px;
  }
`;

export const Heading3 = styled.h3`
  font-size: 16px;
  font-weight: bold;
`;

export const TabContent = styled.div`
  padding-bottom: 10px;
`;

export const Well = styled.div`
  background: #f6f6f6;
  border-radius: 8px;
  padding: 16px;
  margin-left: -12.5px;
  margin-right: -12.5px;
  margin-bottom: 30px;
  @media ${breakpoint} {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const WellSubheading = styled.p`
  margin-top: 7px;
  margin-bottom: 0px;
  font-size: 20px;
  @media ${breakpoint} {
    font-size: 24px;
  }
`;

export const ExpertPortrait = styled.div`
  background-image: url('${threeCoachesPortraitUrl}');
  background-position: center;
  background-size: cover;
  width: 85px;
  height: 85px;
  flex-shrink: 0;
  border-radius: 9999px;
`;

export const Button = styled(BaseButton)`
  font-weight: bold;
  width: 100%;
  ${partnerStyled.Sprint`
    background-color: #000;
    color: #fff;
  `}
  @media ${breakpoint} {
    width: auto;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/styles.ts